import { makeStyles, createStyles } from '@material-ui/core/styles';
import { variables } from '@styles';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },
    item: {
      color: variables.colorV2.breadcrumbs.text.default,
      fontWeight: 500,
      fontSize: 14,
      // maxWidth: '30ch',
      // overflow: 'hidden',
      // textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      '&:hover': {
        overflow: 'visible',
        textOverflow: 'unset',
        whiteSpace: 'normal',
      },
    },
    boldItem: {
      fontWeight: 800,
    },
    separator: {
      margin: '0 8px',
      color: variables.colorV2.breadcrumbs.text.separator,
      fontSize: 14,
      userSelect: 'none',
    },
  }),
);
